import { createUseStyles } from "react-jss";
import { ITheme } from "../../constants/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  content: {
    marginTop: 70,
    padding: theme.spacing.space16,
    paddingTop: 0,
    paddingBottom: 100,
  },
  category: {
    marginTop: theme.spacing.space24,
  },
  bottom: {
    padding: theme.spacing.space16,
    position: "fixed",
    width: `calc(100% - ${theme.spacing.space32}px)`,
    bottom: 0,
    paddingBottom: theme.spacing.space32,
    background: theme.colors.background1,
  },
}));
